import * as React from "react";
import styled, { css } from "styled-components";
import useHistory from "routing/useHistory";
import { Row, Col, Button } from "components/bootstrap";
import { DocumentTitle, PageHeader, Icon } from "components/common";
import IndicesPageNavigation from "components/indices/IndicesPageNavigation";
import DocsHelper from "util/DocsHelper";
import ArchiveRoutes from "archive/Routes";
import ArchiveIndexSetConfigurationForm from "./components/ArchiveIndexSetConfigurationForm";
const HeaderTitle = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.sm};
    margin-bottom: ${theme.spacings.xs};
  `
);
const RestoredIndexSetConfigurationPage = () => {
  const { push } = useHistory();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Configure Index Set: Restored Archives" }, /* @__PURE__ */ React.createElement(IndicesPageNavigation, null), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(HeaderTitle, null, /* @__PURE__ */ React.createElement(Button, { onClick: () => push(ArchiveRoutes.INDEX_SET.SHOW) }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_left_alt", size: "sm" }), " Back"), "Configure Index Set: Restored Archives"),
      documentationLink: {
        title: "Index model documentation",
        path: DocsHelper.PAGES.INDEX_MODEL
      }
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ArchiveIndexSetConfigurationForm, null)))));
};
export default RestoredIndexSetConfigurationPage;
